<template>
  <form @keydown="clearFormValidationError" @change="clearFormValidationError" @submit.prevent="store">
    <div class="set-after" v-if="form.code">
      <label for="code">Discount code</label>
      <div class="input-group">
        <input id="code" type="text" name="code" v-model="form.code" class="long-input form-control" disabled>
          <span class="input-group-btn">
            <button class="btn btn-default" type="button" @click.prevent="copySignUpLink">Copy sign up link</button>
          </span>
      </div>
    </div>

    <div class="set-after">
      <label for="percent">Percent</label>
      <input id="percent" type="text" name="percent" v-model="form.percent" class="long-input">

      <validation-message :errors="form.errors" property-name="percent"></validation-message>
    </div>

    <template v-if="!code.id">
      <div class="set-after">
        <label for="is_permanent">
          <input id="is_permanent" type="checkbox" name="is_permanent" v-model="form.is_permanent">
          Multiple user offer
        </label>

        <validation-message :errors="form.errors" property-name="is_permanent"></validation-message>
      </div>
    </template>

    <div class="set-after" v-if="form.id">
      <p>{{form.is_permanent ? 'This code is for multiple users' : 'This code is not for multiple users'}}</p>
    </div>

    <div class="set-after" v-if="!code.id || (form.is_permanent)">
      <label for="expires_at">Expires at</label>
      <input id="expires_at" type="date" name="expires_at" v-model="form.expires_at" class="long-input">

      <validation-message :errors="form.errors" property-name="expires_at"></validation-message>
    </div>

    <button type="submit" class="big-purple-button" :disabled="saving">Save</button>
  </form>
</template>


<script>
  import Form from './../../../../Form';
  import discountCodeApi from './../../../../api/discount-code';

  export default {
    props: {
      code: {
        required: false,
        type: [Object, null],
        default() {
          return {}
        }
      },
      listLink: {
        required: false,
        type: [String, null],
      },
      signUpLink: {
        required: false,
        type: [String, null],
      },
    },
    data() {
      return {
        form: new Form({
          percent: null,
          is_permanent: false,
          expires_at: null,
          ...this.code,
        }),
        saving: false,
      }
    },
    mounted() {
      this.configureForm();
      if (this.code.id && this.code.is_permanent) {
        this.form.expires_at = this.form.expires_at.split(' ')[0];
      }
    },
    methods: {
      configureForm() {
        this.form.errors.setFocusOnErrorInput(false);
        this.form.errors.setAutoscrollToErrors(false);
        this.form.errors.setErrorsPopup(false);
      },
      clearFormValidationError(event) {
        if (event.target.name) {
          this.form.errors.clear(event.target.name);
        }
      },
      store() {
        this.saving = true;

        //Editing
        if (this.code.id) {
          discountCodeApi.update(this.form, this.code.id).then(() => {
            toastr.success('Discount code was updated successfully');

            this.saving  = false;
          }).catch(this.errorHandler);

          return;
        }

        discountCodeApi.store(this.form).then((code) => {
          toastr.success('Discount code was created successfully');

          this.saving  = false;
          if (this.listLink) {
            setTimeout(() => {
              location.href = `${this.listLink}/${code.id}/edit`;
            }, 3000);
          }
        }).catch(this.errorHandler);
      },
      errorHandler(error) {
        this.saving = false;

        if (error.status == 422) {
          return;
        }

        toastr.error('Something went wrong. Please try again later');
      },
      copySignUpLink() {
        if (!this.code.id) return;

        const el = document.createElement('textarea');

        el.value = `${this.signUpLink}?discount_code=${this.code.code}`;
        el.setAttribute('readonly', '');
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);

        toastr.success('Sign up link with discount code was copied into clipboard successfully');
      },
    },
    watch: {
      'form.is_permanent'(value) {
        if (!value) {
          this.form.expires_at = null;
        }
      }
    },
  }
</script>

<style scoped>
  #code {
    background: #dddddd;
  }
</style>